import React, { useRef } from "react";
import classNames from "classnames";
import "components/popover/popover.scss";
import useOutsideAlerter from "hooks/useOutsideAlerter/useOutsideAlerter";

const Pane = (props: any) => (
  <div className="ui-popover_pane ui-popover_scrollable ui-popover_scrollable-vertical">{props.children}</div>
);

const Section = (props: any) => <div className="ui-popover_section">{props.children}</div>;

const Popover = (props: any) => {
  const popOverRef = useRef();
  useOutsideAlerter(popOverRef, () => {
    if (props.handleClosePopover) {
      void props.handleClosePopover();
    }
  });

  return (
    <>
      {props.activator}
      <div
        ref={popOverRef}
        className={classNames("ui-popover_overlay ui-positioned-overlay", {
          "ui-popover_overlay--open": props.active,
          [`ui-popover_overlay-position-${props?.position}`]: props?.position,
        })}
      >
        <div className="ui-popover">
          <div className={classNames("ui-popover_wrapper", {"ui-popover_wrapper-overflow": props?.overflow})}>
            <div className="ui-popover_content"
            onMouseDown={e => e.stopPropagation()}
            onClick={e => e.stopPropagation()}
            >
              {props.sectioned ? (
                <>
                  {React.Children.map(props.children, child => {
                    if (child.type.displayName === "Pane") {
                      return <>{child}</>;
                    } else {
                      return <Section>{props.children}</Section>;
                    }
                  })}
                </>
              ) : (
                <>{props.children}</>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Pane.displayName = "Pane";
Section.displayName = "Section";
Popover.Pane = Pane;
Popover.Section = Section;

export default Popover;
